<template>
  <div class="contact-form">
    <div class="form-group form-inline">
      <label>{{ $t('root.filters.connected_with_contact') }}</label>
      <label>{{ $t('root.filters.true') }}<input type='radio' v-model='isConnected' :value='true' /></label>
      <label>{{ $t('root.filters.false') }}<input type='radio' v-model='isConnected' :value='false' /></label>
    </div>

    <label>{{ $t('root.filters.operator') }}</label>
    <select v-model='predicate' :disabled='!isConnected'>
      <option :value='true'>{{ $t('root.filters.is') }}</option>
      <option :value='false'>{{ $t('root.filters.is_not') }}</option>
    </select>

    <label>{{ $t('root.filters.contact_name') }}</label>
    <multi-select v-model='selectedContacts' :getter='getContacts' :disabled='!isConnected' />

    <div class="float-right">
      <button class="btn-sm btn btn-neutral m-r-10" @click.prevent="$emit('cancel')">{{ $t('root.filters.cancel') }}</button>
      <button class="btn-sm btn btn-primary" @click.prevent='filter'>{{ $t('root.filters.apply') }}</button>
    </div>
  </div>
</template>

<script>
  import _multi_select from '../../shared/_infinite_multi_select'

  export default {
    components: {
      'multi-select': _multi_select,
    },
    props: {
      folder: {
        type: Object,
      },
    },
    data() {
      return {
        predicate: true,
        isConnected: true,
        selectedContacts: [],
      }
    },
    computed: {
      selectedContactIds() {
        return this.selectedContacts.map(c => c.id)
      },
      predicateQuery() {
        return this.predicate ? 'filters[contact_id_in]' : 'filters[contact_id_not_in]'
      }
    },
    methods: {
      filter() {
        let newQuery = Object.assign({}, this.query)

        if (this.folder)
          newQuery = Object.assign({}, newQuery, { parent_id: this.folder.id })

        delete newQuery['filters[contact_id_not_null]']
        delete newQuery['filters[contact_id_in]']
        delete newQuery['filters[contact_id_not_in]']

        if (!this.isConnected) {
          newQuery = Object.assign({}, newQuery, { page: 1, 'filters[contact_id_not_null]': this.isConnected })
        } else {
          newQuery = Object.assign({}, newQuery, { page: 1, [this.predicateQuery]: this.selectedContactIds })
        }

        this.$router.push({ query: newQuery })
      },
      getContacts(params) {
        return this.listStore.getContacts(params)
      },
    }
  }
</script>

<style lang="sass" scoped>
.contact-form
  width: 325px
  padding: 10px
  select
    margin-bottom: 15px
  .custom-select
    margin-bottom: 15px
.form-inline
  label
    margin-right: 10px
    &:first-child
      margin-right: 15px
  input
    margin-left: 3px
</style>
